import Vue from 'vue'
import configs from '@/config'

const { ahaaiv2Url } = configs

// The converter reads the source slide's canvas blocks from S3 and creates a
// slide through the main API before answering, so it needs the same headroom
// as the other ahaaiv2 calls (see aiInsights.js).
export const CONTENT_CONVERT_TIMEOUT_MS = 45000
export const hasContentConvertApi = Boolean(ahaaiv2Url)

let resource = null

export const actions = {
  convertSlide: {
    method: 'POST',
    url: `${ahaaiv2Url}/api/ai-v2/content/convert-slide`,
    timeout: CONTENT_CONVERT_TIMEOUT_MS,
  },
  // Same endpoint as SlideApi.getSlideById, redeclared here so the Vuex
  // module stays store-pure (see contentV2Convert.module.js).
  getSlideById: {
    method: 'GET',
    url: `${configs.baseUrl}/api/slide/{slideId}`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

/**
 * AHA-47744: deterministic (no LLM) conversion of a legacy content slide into a
 * NEW content-v2 slide inserted right after the source. The source slide is
 * never modified. Resolves with `{ new_slide_id, source_slide_id, source_type,
 * dsl, blocks_in, blocks_out, warnings: [{ code, message, block_id }] }`.
 * Errors carry `body.detail = { code, message }` (vue-resource response shape).
 */
const convertSlide = async ({ presentationId, slideId }) => {
  const res = await resource.convertSlide({}, {
    presentation_id: String(presentationId),
    slide_id: slideId,
  })
  return res.body
}

/** Resolves with the slide row (`res.body.data`), or null when absent. */
const getSlideById = async (slideId) => {
  const res = await resource.getSlideById({ slideId })
  return res?.body?.data || null
}

export default {
  initResource,
  convertSlide,
  getSlideById,
}
